module.exports = __webpack_public_path__ + "img/95dfe2c.png";